import { useMemo } from 'react'

import { IRQCategorySeverity } from '@/gen/inventory/v1/company_service_pb'

import { sortIrqCategorySeverities } from '@/pages/company-drawer/company-overview/set-irq-modal/utils'

import { RiskBadge } from '@/components/shared/risk-badge/risk-badge'

type IrqCategoryListProps = {
  irqCategorySeverities: IRQCategorySeverity[]
  isEstimated: boolean
}

export const IrqCategoryList = ({ irqCategorySeverities, isEstimated }: IrqCategoryListProps) => {
  const sorted = useMemo(
    () => sortIrqCategorySeverities(irqCategorySeverities),
    [irqCategorySeverities],
  )
  return (
    <ul className='flex w-48 shrink-0 flex-col gap-4 pt-2'>
      {sorted.map(({ category, severity }) => (
        <li key={category} className='flex items-center gap-1.5'>
          <RiskBadge
            riskLevel={severity}
            size='icon'
            variant={isEstimated ? 'estimated' : 'default'}
          />
          <span className='text-main-foreground-primary text-body-default'>{category}</span>
        </li>
      ))}
    </ul>
  )
}
